// Utilities for manipulating the DOM.

export const removeAllChildren = element => {
  while (element.firstChild) {
    element.removeChild(element.firstChild)
  }
}
